import { render, staticRenderFns } from "./add_hair.vue?vue&type=template&id=5ae4e8ec&scoped=true&"
import script from "./add_hair.vue?vue&type=script&lang=js&"
export * from "./add_hair.vue?vue&type=script&lang=js&"
import style0 from "./add_hair.vue?vue&type=style&index=0&id=5ae4e8ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae4e8ec",
  null
  
)

export default component.exports